const baseStyle = {
    transitionProperty: 'common',
    transitionDuration: 'fast',
    transitionTimingFunction: 'ease-out',
    cursor: 'pointer',
    textDecoration: 'none',
    outline: 'none',
    color: 'text.neutral.primary.default',
    _hover: {
        textDecoration: 'underline'
    },
    _focus: {
        textDecoration: 'underline',
        boxShadow: 'none'
    },
    _activeLink: {
        color: 'text.accent.primary.default'
    },
    _active: {
        color: 'text.accent.primary.default'
    },
    _disabled: {
        color: 'text.neutral.primary.disabled'
    },
    _focusVisible: {
        textDecoration: 'underline'
    }
};
const variants = {
    deezer: {
        color: 'text.accent.primary.default',
        _hover: {
            color: 'text.accent.primary.hovered',
            textDecoration: 'none'
        },
        _focus: {
            textDecoration: 'underline'
        },
        _focusVisible: {
            textDecoration: 'underline',
            outline: 'none'
        }
    },
    navlink: {
        color: 'text.neutral.primary.default',
        _active: {
            color: 'text.accent.primary.hovered'
        },
        _hover: {
            color: 'primary.700',
            textDecoration: 'none'
        },
        _focus: {
            textDecoration: 'underline'
        },
        _focusVisible: {
            textDecoration: 'underline',
            outline: 'none'
        }
    },
    bold: {
        fontWeight: 'bold'
    }
};
export const ThemedLink = {
    baseStyle,
    variants
};

//# sourceMappingURL=Link.js.map